import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { Link, NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Op36Icon } from '../../assets/images/common/icons/sidebarMenu/Op36.svg'
import PortalUserMenu from './PortalUserMenu'

import classes from './PortalTopBar.module.scss'

const tabClassName = ({ isActive }) => classNames('d-flex align-items-center', classes.tab, { [classes.active]: isActive })

const PortalTopBar = () => {
  const { t } = useTranslation()
  const user = useSelector(state => state.user.current_user)

  return (
    <header className={classes.topBar}>
      <div className={classNames('d-flex align-items-center h-100 mx-auto', classes.topBarInner)}>
        <Link to='/portal' className='d-flex align-items-center'>
          <Op36Icon className={classes.op36Icon} />
        </Link>
        <nav className={classNames('d-flex align-items-center h-100', classes.tabs)}>
          <NavLink to='/portal' end className={tabClassName}>{t('portal.topBar.home')}</NavLink>
          <NavLink to='/portal/certifications' className={tabClassName}>{t('portal.topBar.certification')}</NavLink>
        </nav>
        <PortalUserMenu user={user} />
      </div>
    </header>
  )
}

export default PortalTopBar
